import type { DigitalAsset } from "../types";

interface DetailsSectionProps {
  asset: DigitalAsset;
  canOpenOffice: boolean;
  onOpenOffice: () => void;
}

const DetailsSection = ({
  asset,
  canOpenOffice,
  onOpenOffice,
}: DetailsSectionProps) => (
  <div className="mt-4 bg-white rounded-lg box-shadow">
    <div className="text-quinary font-bold font-sans py-2 px-6 mx-2">
      Details
    </div>

    <div className="grid grid-cols-2 text-xs">
      <div className="grid grid-cols-1 py-2 px-4 space-y-2">
        <label className="mx-4 expandedLabel fontExpand">Office Name:</label>

        {asset.officeName && asset.officeName !== "NULL" && (
          <>
            {canOpenOffice ? (
              <div
                className="blueAndBold underline expandedData fontExpand text-xs cursor-pointer mx-4"
                onClick={onOpenOffice}
              >
                {asset.officeName}
              </div>
            ) : (
              <div className="expandedData fontExpand text-xs mx-4">
                {asset.officeName}
              </div>
            )}
          </>
        )}

        <div className="border-b border-gray-200"></div>
      </div>

      <div className="grid grid-cols-1 py-2 px-4 space-y-2">
        <label className="mx-4 expandedLabel fontExpand">Agency:</label>
        <div className="mx-4 expandedData fontExpand">
          {asset.agency && asset.agency !== "NULL" ? asset.agency : ""}
        </div>
        <div className="border-b border-gray-200"></div>
      </div>

      <div className="grid grid-cols-1 py-2 px-4 space-y-2">
        <label className="mx-4 expandedLabel fontExpand">Office Code:</label>
        <div className="mx-4 expandedData fontExpand">
          {asset.officeCode && asset.officeCode !== "NULL"
            ? asset.officeCode
            : ""}
        </div>
        <div className="border-b border-gray-200"></div>
      </div>

      <div className="grid grid-cols-1 py-2 px-4 space-y-2">
        <label className="mx-4 expandedLabel fontExpand">Office Status:</label>
        <div className="mx-4 expandedData fontExpand">
          {asset.officeStatus && asset.officeStatus !== "NULL"
            ? asset.officeStatus
            : ""}
        </div>
        <div className="border-b border-gray-200"></div>
      </div>

      <div className="grid grid-cols-1 py-2 px-4 space-y-2">
        <label className="mx-4 expandedLabel fontExpand">Corp. Office#:</label>
        <div className="mx-4 expandedData fontExpand">
          {asset.storeNumber && asset.storeNumber !== "NULL"
            ? asset.storeNumber
            : ""}
        </div>
        <div className="border-b border-gray-200"></div>
      </div>

      <div className="grid grid-cols-1 py-2 px-4 space-y-2">
        <label className="mx-4 expandedLabel fontExpand">
          Digital Tracking Number:
        </label>
        <div className="mx-4 expandedData fontExpand">
          {asset.digital_Tracking_Number__C &&
          asset.digital_Tracking_Number__C !== "NULL"
            ? asset.digital_Tracking_Number__C
            : ""}
        </div>
        <div className="border-b border-gray-200"></div>
      </div>

      <div className="grid grid-cols-1 py-2 px-4 space-y-2">
        <label className="mx-4 expandedLabel fontExpand">
          Last Date Modified:
        </label>
        <div className="mx-4 expandedData fontExpand">
          {asset.updatedOn
            ? new Date(asset.updatedOn).toLocaleDateString()
            : ""}
        </div>
        <div className="border-b border-gray-200"></div>
      </div>

      <div className="grid grid-cols-1 py-2 px-4 space-y-2">
        <label className="mx-4 expandedLabel fontExpand">
          Online Directories Brand Name:
        </label>
        <div className="mx-4 expandedData fontExpand">
          {asset.online_Directories_Brand_Name__C &&
          asset.online_Directories_Brand_Name__C !== "NULL"
            ? asset.online_Directories_Brand_Name__C
            : ""}
        </div>
        <div className="border-b border-gray-200"></div>
      </div>

      <div className="grid grid-cols-1 py-2 px-4 space-y-2">
        <label className="mx-4 expandedLabel fontExpand">Services:</label>
        <div className="mx-4 expandedData fontExpand">
          {asset.serviceName && asset.serviceName !== "NULL"
            ? asset.serviceName
            : ""}
        </div>
      </div>

      <div className="grid grid-cols-1 py-2 px-4 space-y-2">
        <label className="mx-4 expandedLabel fontExpand">
          Short Description:
        </label>
        <div className="mx-4 expandedData fontExpand">
          {asset.shortDescription && asset.shortDescription !== "NULL"
            ? asset.shortDescription
            : ""}
        </div>
      </div>
    </div>
  </div>
);

export default DetailsSection;